import React, { useMemo } from 'react';
import cn from 'classnames';

import TriangleIcon from '@lt/components/icons-react/rebrand/TriangleDown';
import { PRICE_CHANGE_DIRECTION } from 'src/routes/Checkout/store/constants/actualization';
import { TEST_ID_PRICE_WARNING } from './constants';
import { getPriceNoticeText } from './utils';

import styles from './priceWarning.module.css';

interface Props {
  oldPrice: number;
  currentPrice: number;
  isMobile: boolean;
}

const PriceWarning = ({ oldPrice, currentPrice, isMobile }: Props) => {
  const changeDirection =
    currentPrice > oldPrice
      ? PRICE_CHANGE_DIRECTION.UP
      : PRICE_CHANGE_DIRECTION.DOWN;

  const { title, description } = useMemo(() => {
    const isPriceChangedSignificantly =
      Math.abs(currentPrice - oldPrice) >= oldPrice * 0.1;

    return getPriceNoticeText(changeDirection, isPriceChangedSignificantly);
  }, [changeDirection, currentPrice, oldPrice]);

  return (
    <div
      className={cn(styles.container, {
        [styles.mobileContainer]: isMobile,
        [styles.changeUpContainer]: changeDirection === 'up',
      })}
      data-testid={TEST_ID_PRICE_WARNING}
    >
      <TriangleIcon
        className={cn(styles.icon, {
          [styles.mobileIcon]: isMobile,
          [styles.changeUpIcon]: changeDirection === 'up',
        })}
      />
      <div
        className={cn(styles.text, {
          [styles.mobileText]: isMobile,
          [styles.changeUpText]: changeDirection === 'up',
        })}
      >
        {`${title} ${description}`}
      </div>
    </div>
  );
};

export default PriceWarning;
